import {
  PresetAspectRatio,
  PresetLanguage,
  PresetReframeMode,
  PresetType,
} from './types/shortsPresetType';

export const PRESET_TYPE_OPTIONS: { value: PresetType; label: string }[] = [
  { value: 'clip', label: 'Clip' },
  { value: 'digest', label: 'Digest' },
];

export const PRESET_ASPECT_RATIO_OPTIONS: { value: PresetAspectRatio; label: string }[] = [
  { value: '9:16', label: '9:16' },
  { value: '1:1', label: '1:1' },
];

export const PRESET_REFRAME_MODE_OPTIONS: { value: PresetReframeMode; label: string }[] = [
  { value: 'auto', label: 'Auto' },
  { value: 'crop', label: 'Crop' },
  { value: 'pad', label: 'Pad' },
];

export const PRESET_LANGUAGE_OPTIONS: { value: PresetLanguage; label: string }[] = [
  { value: 'en', label: 'English (en)' },
  { value: 'ko', label: 'Korean (ko)' },
  { value: 'jp', label: 'Japanese (jp)' },
  { value: 'es', label: 'Spanish (es)' },
  { value: 'zh', label: 'Chinese (zh)' },
  { value: 'vi', label: 'Vietnamese (vi)' },
];

export const PRESET_TYPE_LABELS: Record<PresetType, string> = {
  clip: 'Clip',
  digest: 'Digest',
};

export const PRESET_REFRAME_MODE_LABELS: Record<PresetReframeMode, string> = {
  crop: 'Crop',
  pad: 'Pad',
  auto: 'Auto',
};

export const PRESET_LANGUAGE_LABELS: Record<PresetLanguage, string> = {
  en: 'English',
  ko: 'Korean',
  jp: 'Japanese',
  es: 'Spanish',
  zh: 'Chinese',
  vi: 'Vietnamese',
};

/** Backend default when reframe_mode is omitted. */
export const PRESET_DEFAULT_REFRAME_MODE: PresetReframeMode = 'auto';

/**
 * Non-binding guidance shown next to the type select. The backend enforces only
 * `>= 1` on the numeric fields — these are conventions, not validation.
 */
export const PRESET_TYPE_HINTS: Record<PresetType, string> = {
  clip: 'Typically 15–60s, 3–5 per episode',
  digest: 'Typically 120–180s, 1 per episode',
};

/** Placeholder for optional fields left unset — distinguishes null from an empty string. */
export const PRESET_EMPTY_DISPLAY = '-';

/** Backend caps page size at 100. Used by the Season-edit select, which loads a single page. */
export const PRESET_MAX_PAGE_SIZE = 100;

export const PRESET_TABLE_PAGE_SIZE = 20;

/**
 * Work-order feed window, fixed server-side (the spec's rolling 72 hours) — there is no
 * parameter to widen it. Shown as text so nobody looks for a control that does not exist.
 */
export const WORK_ORDER_WINDOW_DAYS = 3;

/** Server caps the feed at this many items, dropping the oldest first. */
export const WORK_ORDER_MAX_ITEMS = 200;

/** Playlist type that carries a shorts order. Only this type may link a preset. */
export const WORK_ORDER_PLAYLIST_TYPE = 'bebridge';
